import { render, staticRenderFns } from "./details.vue?vue&type=template&id=59eeae66&scoped=true&"
import script from "./details.vue?vue&type=script&lang=js&"
export * from "./details.vue?vue&type=script&lang=js&"
import style0 from "./details.vue?vue&type=style&index=0&id=59eeae66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59eeae66",
  null
  
)

export default component.exports